import React from "react";
import Meaning from "./Meaning";
import Phonetics from "./Phonetics";

export default function Results({ results }) {
  return (
    <div>
      <h2>{results.word}</h2>

      {results.phonetics.map((phonetic, index) => (
        <Phonetics key={index} phonetic={phonetic} />
      ))}

      {results.meanings.map((meaning, index) => (
        <Meaning key={index} meaning={meaning} />
      ))}
    </div>
  );
}